import { useContext } from 'react';

import { ContainerContext } from '../../inversify/container';

export function useContainer() {
  return useContext(ContainerContext);
}
